/**
 * Conversão entre o slug kebab persistido no back (regex ^[a-z0-9][a-z0-9-]{0,31}$)
 * e o nome PascalCase que lucide-react/IconPicker usam. Extensão local — não
 * existe na ref (lá o icon é salvo em PascalCase direto).
 */

/** Regex VERBATIM do back (docs/spec-gestao-arvores.md § Editar canal): slug de 1 a 32 chars. */
export const ICON_SLUG_RE = /^[a-z0-9][a-z0-9-]{0,31}$/

/** Nome PascalCase cujo slug o back aceita. O catálogo só oferece o que cabe. */
export function fitsSlugContract(name: string): boolean {
  return ICON_SLUG_RE.test(pascalToKebab(name))
}

/** `'shopping-cart' → 'ShoppingCart'`; segmento iniciado por dígito fica como está (`'2x2' → '2x2'`). */
export function kebabToPascal(slug: string): string {
  return slug
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('')
}

/**
 * `'ShoppingCart' → 'shopping-cart'`. Quebra antes de TODA maiúscula (inclusive
 * runs consecutivas: `XCircle → x-circle`, `AArrowDown → a-arrow-down`,
 * `ArrowDownAZ → arrow-down-a-z`) e antes de dígito. Pode divergir do kebab
 * canônico do lucide (`Grid2x2 → grid-2x-2`), mas o round-trip via kebabToPascal
 * devolve o PascalCase original pra todo o catálogo lucide — invariante que
 * importa (slug é encoding nosso, não precisa ser o do lucide).
 */
export function pascalToKebab(name: string): string {
  return name
    .replace(/([A-Za-z0-9])(?=[A-Z])/g, '$1-')
    .replace(/([A-Za-z])(?=\d)/g, '$1-')
    .toLowerCase()
}
